import { Grid } from '@mui/material';
import { usePqrTimesFilters } from './hook';
import { PqrTimesFiltersProps } from './props';
import FieldText from '../../../../components/general/fields/fieldText';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { Checkbox } from '../../../../components/general/fields/checkbox';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../shared/utils/params';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import dayjs from 'dayjs';

export const PqrTimesFilters = ({
    onFilter,
    loading,
}: PqrTimesFiltersProps) => {
    const {
        formik,
        typeDays,
        typeTimes,
        receptionChannels,
        halfs,
        subtypeDps,
        procedures,
        typePqr,
    } = usePqrTimesFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(receptionChannels)}
                    label="Canal de recepción"
                    name="receptionChannel"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.receptionChannel}
                    errors={formik.errors.receptionChannel}
                    value={formik.values.receptionChannel}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('receptionChannel', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typeTimes)}
                    label="Estado de la Regla"
                    name="status"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('status', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typeDays)}
                    label="Fecha base para calculo de días"
                    name="typeDay"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typeDay}
                    errors={formik.errors.typeDay}
                    value={formik.values.typeDay}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typeDay', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(halfs)}
                    label="Medio"
                    name="half"
                    size="small"
                    disabled={halfs.length === 0}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.half}
                    errors={formik.errors.half}
                    value={formik.values.half}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('half', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
                <FieldText
                    label="No. Regla"
                    name="rule"
                    size="small"
                    touched={formik.touched.rule}
                    errors={formik.errors.rule}
                    value={formik.values.rule}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(subtypeDps)}
                    label="Subtipo DP"
                    name="subtypeDp"
                    size="small"
                    disabled={subtypeDps.length === 0}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.subtypeDp}
                    errors={formik.errors.subtypeDp}
                    value={formik.values.subtypeDp}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('subtypeDp', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typePqr)}
                    label="Tipo PQR"
                    name="type"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.type}
                    errors={formik.errors.type}
                    value={formik.values.type}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('type', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(procedures)}
                    label="Trámite"
                    name="procedure"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.procedure}
                    errors={formik.errors.procedure}
                    value={formik.values.procedure}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('procedure', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación inicial"
                    name="startCreatedAt"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    touched={formik.touched.startCreatedAt}
                    errors={formik.errors.startCreatedAt?.toString()}
                    value={formik.values.startCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('startCreatedAt', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación final"
                    name="endCreatedAt"
                    size="small"
                    minDate={dayjs(formik.values.startCreatedAt)}
                    maxDate={dayjs().endOf('day')}
                    disabled={!formik.values.startCreatedAt}
                    touched={formik.touched.endCreatedAt}
                    errors={formik.errors.endCreatedAt?.toString()}
                    value={formik.values.endCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('endCreatedAt', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
